// Mock data extracted from SNZ Education website
export const siteInfo = {
  name: "SNZ Education",
  tagline: "Unlock Your Global Future",
  email: "education.snz@gmail.com",
  phone: "+91 73839 02131",
  phoneRaw: "+917383902131",
  whatsapp: "https://wa.me/917383902131",
  address:
    "SNZ Education, 9/B, Madni Park Society, Salatia Rd, nr. AIM International School, Anand, Gujarat - 388001",
  hours: {
    weekdays: "Monday - Saturday\u00a0\u00a010:00 AM - 6:00 PM",
    sunday: "Sunday\u00a0\u00a0Closed",
  },
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "English Coaching", path: "/english-coaching" },
  { label: "Student Visa", path: "/student-visa" },
  { label: "Testimonials", path: "/testimonials" },
  { label: "Contact", path: "/contact" },
];

// ---------------------------------------------------------------
// PLACEHOLDER FOUNDER DATA - replace names/bios/photos below
// ---------------------------------------------------------------
export const founders = [
  {
    name: "Mr. Shahilsha Diwan",
    role: "Founder & Owner",
    bio: "With years of experience guiding aspiring students abroad, Shahilsha founded SNZ Education to bring world-class study-abroad counselling to Anand. He personally mentors students on choosing the right destination, course, and university.",
    photo: "shahil.png",
    socials: { linkedin: "https://www.linkedin.com/in/shahilshadiwan/", email: "education.snz@gmail.com" },
    highlights: [
      "7+ years in education industry",
      "500+ students guided to 7+ countries",
      "Expert in university selection & visa counseling",
    ],
  },
  {
    name: "Mrs. Naylah Diwan",
    role: "Co-Founder & Head of Coaching",
    bio: "Naylah leads the IELTS, PTE, and Spoken English programs at SNZ Education. A certified trainer with a passion for teaching, she has helped many students achieve their target band scores on the first attempt.",
    photo: "naylah.png",
    socials: { linkedin: "https://www.linkedin.com/in/naylah-diwan-698a6a2b9/", email: "education.snz@gmail.com" },
    highlights: [
      "Certified IELTS & PTE trainer",
      "Specialist in speaking & writing modules",
      "1:1 personalized coaching approach",
    ],
  },
];

export const milestones = [
  { year: "2014", title: "Journey began", desc: "SNZ Education founded in Anand with a vision to make study-abroad accessible." },
  { year: "2017", title: "100+ students", desc: "Crossed our first century of successful student placements abroad." },
  { year: "2020", title: "Online coaching", desc: "Launched dedicated IELTS / PTE online coaching with mock platforms." },
  { year: "2024", title: "7+ countries", desc: "Active visa & admission support across USA, UK, Canada, AUS, NZ, Europe, Dubai." },
];

// Photo testimonials (replace with real students)
export const photoTestimonials = [
  {
    name: "Zeba Shaikh",
    initial: "Z",
    tag: "PTE Coaching",
    quote:
      "I am student of SNZ Education. The teachers are excellent and their students achieve very good results. I highly recommend SNZ Education for PTE Coaching.",
    rating: 5,
    country: "in",
  },
  {
    name: "Saiyad Asim",
    initial: "A",
    tag: "PTE Coaching",
    quote:
      "Experienced and supportive teachers. Easy-to-understand teaching methods. Friendly learning environment. Good study materials and notes. Regular tests and practice sessions. Personal guidance and doubt-solving support",
    rating: 5,
  },
  {
    name: "Adib Kazi",
    initial: "A",
    tag: "IELTS Coaching",
    quote:
      "I am student of SNZ Education. I am preparing for IELTS from here. They teach very well here. I am learning new strategy and techniques every day. MUST visit here for coaching.",
    rating: 5,
  },
  {
    name: "Ziyafatema Saiyed",
    initial: "Z",
    tag: "PTE Coaching",
    quote:
      "I am student of SNZ Education. From my perspective genuinely SNZ Education is best platform for PTE and IELTS exam's. Everything here was taught by highly qualified and experienced teachers and everything was taught in detail from the basic to advance. Here in SNZ Education I was learning for my PTE exam and it was all worth it and very beneficial for me",
    rating: 5,
  },
  {
    name: "Sarfaraz Diwan",
    initial: "S",
    tag: " Coaching",
    quote:
      "I am student of SNZ Education. From my perspective genuinely SNZ Education is best platform for PTE and IELTS exam's. Everything here was taught by highly qualified and experienced teachers and everything was taught in detail from the basic to advance. Here in SNZ Education I was learning for my PTE exam and it was all worth it and very beneficial for me",
    rating: 5,
  },
];

// ---------------------------------------------------------------
// Vertical (9:16) "Reels-style" video testimonials.
// Replace `videoUrl` with your self-hosted MP4 (portrait orientation).
// You can also host MP4s in /public/videos and reference them as
// "/videos/student-1.mp4" — paths are relative thanks to homepage:"."
// ---------------------------------------------------------------
export const videoTestimonials = [
  {
    name: "Maharshi Joshi",
    tag: "New Zealand",
    location: "Auckland",
    videoUrl:
      "https://www.instagram.com/reel/DYw22qNlRes/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==",
    poster:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=600&q=80",
    summary: "SNZ Education made my NZ student visa journey incredibly smooth.",
    country: "nz",
  },
  {
    name: "Mariya Vahora",
    tag: "Canada Study Permit",
    location: "Toronto",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4",
    poster:
      "https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=600&q=80",
    summary: "End-to-end Canada study permit journey with SNZ Education.",
    country: "ca",
  },
  {
    name: "Sahil Makwana",
    tag: "UK Student Visa",
    location: "London",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4",
    poster:
      "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=600&q=80",
    summary: "Cracked IELTS and landed UK university admission with SNZ.",
    country: "gb",
  },
  {
    name: "Nihir Dodiya",
    tag: "Australia Student Visa",
    location: "Melbourne",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4",
    poster:
      "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?auto=format&fit=crop&w=600&q=80",
    summary: "From Anand to Melbourne — couldn't have done it without SNZ.",
    country: "au",
  },
  {
    name: "Sonam Kumari",
    tag: "NZ Student Visa",
    location: "Wellington",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4",
    poster:
      "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=600&q=80",
    summary: "Personalized assistance through every step of my visa process.",
    country: "nz",
  },
  {
    name: "Sahil Shaikh",
    tag: "UK Student Visa",
    location: "Manchester",
    videoUrl:
      "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4",
    poster:
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=600&q=80",
    summary: "SNZ helped me find the best university in the UK.",
    country: "gb",
  },
];

export const heroBadges = [
  { label: "IELTS" },
  { label: "PTE" },
];

export const aboutFeatures = [
  {
    title: "Personalized Coaching",
    desc: "Comprehensive trainings, Smart strategies, and practice sessions to help you achieve a high band score.",
  },
  {
    title: "Student Success",
    desc: "End-to-end guidance and transparent counseling for top international study destinations.",
  },
  {
    title: "Global Opportunities",
    desc: "Apply for your student visa, arrange accommodation, and book your flights to align with your study abroad dream.",
  },
];

export const services = [
  {
    tag: "Language Mastery",
    title: "IELTS / PTE / Spoken English",
    desc: "Expert coaching for IELTS, PTE, and spoken English with personalized training programs. Our comprehensive exam preparation focuses on building communication skills, confidence, and achieving your target scores.",
    cta: "View All Programs",
    path: "/english-coaching",
    icon: "GraduationCap",
  },
  {
    tag: "Study Abroad",
    title: "Student Visa",
    desc: "Complete study abroad guidance with end-to-end visa support. From counseling and university selection to application assistance and visa processing, we ensure a smooth journey to your dream destination.",
    cta: "Explore Visa Services",
    path: "/student-visa",
    icon: "Plane",
  },
  {
    tag: "Travel Abroad",
    title: "Visitor Visa",
    desc: "Complete travel and tourism guidance with end-to-end visa support. From itinerary planning and document curation to application assistance and embassy submission, we ensure a smooth journey to your dream destination.",
    cta: "Explore Destinations",
    path: "/contact",
    icon: "MapPinned",
  },
];

export const whyChoose = [
  {
    title: "Expert Mentors",
    desc: "Learn from experienced tutors and faculties dedicated to your success.",
    icon: "Users",
  },
  {
    title: "Personalized Guidance",
    desc: "Customized One-to-One counselling tailored to your education path, career, and goal.",
    icon: "Target",
  },
  {
    title: "100% Student Satisfaction",
    desc: "Track record of helping students achieve their academic and career aspirations.",
    icon: "Award",
  },
  {
    title: "Trusted Support",
    desc: "Comprehensive support system ensuring you're never alone on your educational journey.",
    icon: "ShieldCheck",
  },
];

export const destinations = [
  { name: "USA", code: "us", desc: "Student visa guidance for top universities across the United States." },
  { name: "United Kingdom", code: "gb", desc: "Student visa support for prestigious UK universities and Russell Group institutions." },
  { name: "Canada", code: "ca", desc: "Study Permit and PGWP pathway guidance for Canadian colleges and universities." },
  { name: "Australia", code: "au", desc: "Student visa support for Australia's Group of Eight and leading universities." },
  { name: "New Zealand", code: "nz", desc: "Student visa guidance for NZ universities known for quality and post-study work rights." },
  { name: "Europe", code: "eu", desc: "Study in Germany, France, Spain and more - affordable, world-class education." },
  { name: "Dubai / UAE", code: "ae", desc: "Student visa support for international university campuses across the UAE." },
  { name: "And More...", code: "globe", desc: "Russia, Singapore, and other rising destinations - talk to us for tailored advice." },
];

export const testimonials = [
  {
    name: "Zeba Shaikh",
    initial: "Z",
    tag: "PTE Coaching",
    quote:
      "I am student of SNZ Education. The teachers are excellent and their students achieve very good results. I highly recommend SNZ Education for PTE Coaching.",
    rating: 5,
  },
  {
    name: "Saiyad Asim",
    initial: "A",
    tag: "PTE Coaching",
    quote:
      "Experienced and supportive teachers. Easy-to-understand teaching methods. Friendly learning environment. Good study materials and notes. Regular tests and practice sessions. Personal guidance and doubt-solving support",
    rating: 5,
  },
  {
    name: "Adib Kazi",
    initial: "A",
    tag: "IELTS Coaching",
    quote:
      "I am student of SNZ Education. I am preparing for IELTS from here. They teach very well here. I am learning new strategy and techniques every day. MUST visit here for coaching.",
    rating: 5,
  },
];

export const coachingPrograms = [
  {
    tag: "Test Preparation",
    title: "IELTS",
    desc: "Comprehensive IELTS preparation covering Listening, Reading, Writing, and Speaking. Band-focused strategies, regular mock tests, and one-on-one feedback to help you achieve 7+ bands.",
    points: ["Academic & General Training", "Weekly mock tests", "Personalized speaking practice"],
    icon: "BookOpen",
  },
  {
    tag: "Test Preparation",
    title: "PTE Academic",
    desc: "Computer-based PTE coaching focused on AI scoring strategies. Master modules, time management, and key question patterns to crack 70+ scores with confidence.",
    points: ["AI-scoring techniques", "Section-wise understanding", "Real exam simulation"],
    icon: "Laptop",
  },
  {
    tag: "Fluency Building",
    title: "Spoken English",
    desc: "Build everyday English fluency, confidence, and a neutral accent. Perfect for students, professionals, and anyone preparing for interviews or social conversations.",
    points: ["Conversation practice", "Grammar & vocabulary", "Interview preparation"],
    icon: "MessageCircle",
  },
];

export const coachingBenefits = [
  { title: "Certified Trainers", desc: "Learn from trainers with years of experience and proven student results.", icon: "BadgeCheck" },
  { title: "Small Batches", desc: "Limited seats per batch for individual attention and faster progress.", icon: "Users" },
  { title: "Mock Tests", desc: "Regular timed mock tests with detailed analysis to track your improvement.", icon: "ClipboardCheck" },
  { title: "Result-Oriented", desc: "Proven track record of students achieving their target scores on first attempt.", icon: "TrendingUp" },
];

export const coachingSteps = [
  { num: "1", title: "Free Assessment", desc: "Take a diagnostic test to identify your current level and goals." },
  { num: "2", title: "Custom Plan", desc: "Get a personalized study plan tailored to your target score and timeline." },
  { num: "3", title: "Train & Practice", desc: "Live classes, practice sessions, and continuous feedback from mentors." },
  { num: "4", title: "Ace the Exam", desc: "Walk in confident, score high, and unlock your global opportunities." },
];

export const visaSupport = [
  { title: "Personalized Counseling", desc: "One-on-one sessions to understand your goals, strengths, and budget - then match you with the right country, course, and university.", icon: "MessagesSquare" },
  { title: "University Selection", desc: "Shortlist universities based on your profile, scholarships available, course ranking, and career outcomes. No guesswork - only data.", icon: "School" },
  { title: "Application Assistance", desc: "SOPs, LORs, resumes, and application forms - crafted, reviewed, and submitted by experts who know what admission officers want.", icon: "FileText" },
  { title: "Visa Filing", desc: "Complete documentation, financial proof, visa form filing, and embassy appointment scheduling - handled end-to-end by our team.", icon: "Stamp" },
  { title: "Interview Prep", desc: "Mock visa interviews, common question practice, and confidence coaching to help you ace your university and embassy interview with ease.", icon: "Mic" },
  { title: "Pre-Departure", desc: "Accommodation, forex, flight bookings, and pre-departure briefings - start your journey abroad fully prepared and stress-free.", icon: "Luggage" },
];

export const visaSteps = [
  { num: "1", title: "Free Counseling", desc: "Understand your goals and the best-fit destinations for you." },
  { num: "2", title: "University Shortlist", desc: "Curated list of universities matching your profile and budget." },
  { num: "3", title: "Apply & Admit", desc: "Application support and offer letter assistance from start to finish." },
  { num: "4", title: "Visa Approval", desc: "Complete visa filing, interview prep, and embassy coordination." },
  { num: "5", title: "Fly Abroad", desc: "Pre-departure briefing, accommodation, forex - fly with confidence." },
];

export const stats = [
  { value: "7+", label: "Countries Covered" },
  { value: "500+", label: "Students Guided" },
  { value: "99%", label: "Visa Success" },
  { value: "4+", label: "Years Experience" },
];
